import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-blog-new-service-cablefinder-page',
  templateUrl: './blog-new-service-cablefinder-page.component.html',
  styleUrls: ['./blog-new-service-cablefinder-page.component.css']
})
export class BlogNewServiceCablefinderPageComponent implements OnInit {

  constructor(private titleService:Title) { }

  ngOnInit(): void {
    this.titleService.setTitle("Introducing a New Service: Cable Finder");
  }

}
